/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Draft from './Draft/index'
import Final from './Final/index'
import NeedsAction from './NeedsAction/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Status"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Draft'
let letterValueData = fromData.useDataFormat({ viewPath,
context: 'letter',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: letterValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Draft'}>
<Draft
  viewPath={`${viewPath}/Draft`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Final'}>
<Final
  viewPath={`${viewPath}/Final`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NeedsAction'}>
<NeedsAction
  viewPath={`${viewPath}/NeedsAction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}